import { create } from 'zustand';
import type { MembershipSummary } from './api';

type PreAuth = {
  preAuthToken: string;
  memberships: MembershipSummary[];
};

type PreAuthStore = {
  data: PreAuth | null;
  set: (data: PreAuth) => void;
  clear: () => void;
};

export const usePreAuthStore = create<PreAuthStore>((set) => ({
  data: null,
  set: (data) => set({ data }),
  clear: () => set({ data: null }),
}));
